module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('span', {
    staticClass: "Serif_Bold _idGenCharOverride-1"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Opening"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("I")]), _vm._v("t "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("arted badly and only got worse. Blizzards, "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("rikes, unburied bodies, power cuts, terrori"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" threats and Showaddywaddy’s "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Greate")]), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v(" Hits ")]), _vm._v("topping the album charts; 1979 was a cascade of cata"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("rophe. Unless, like Allie Burns, you were a journali"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(". For her tribe, someone else’s bad news was the unmi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("akable sound of opportunity"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" knocking.")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace"
  }, [_vm._v("Allie Burns "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ared out of the train carriage window at white, broken only by a line of telegraph poles. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey were miraculously "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ill dark on one side, sheltered "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om the blu"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ery wind whipping the snow in sudden "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("urries. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e train sat motionless, trapped in "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("mid")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("journey")]), _vm._v(" by dri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("s blocking the tracks. She glanced across at Danny Sullivan. ‘How come winter always brings Scotland to a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ill?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He chuckled. ‘It’s ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" like "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Murder on the Orient Express")]), _vm._v(". Stuck on a train in a s"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("nowdri")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(".’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Only without the murder,’ Allie po"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("inted out.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘OK, only without th"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("e murder.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘And the luxury. And the cocktails. And Albert Finney in a"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" hairnet.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny pulled a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ce. ‘Picky, picky, picky. Anybody would think you were on the subs’ table, "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ddling with my commas and misrelated par"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ticiples.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie laughed. ‘I don’t even know what a misrelated participle is. And I doub"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("t you do.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I did once, if tha"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("t counts?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey subsided into silence again. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey’d met unintentionally on the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("eezing plat"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rm of Haymarket "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ation on the second day of the year, colleagues returning to work a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("er spending Hogmanay with their "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("milies. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere were plenty of her "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("llow hacks Allie would have hidden behind a plat"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rm pillar to avoid, but Danny was probably the lea"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" objectionable of them. If he was sexi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(", raci"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" and sectarian to the core, he’d done a good job of hiding it. And there was no escaping the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ct that a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("er time spent with her parents, she was desperate "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r any conversation "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om her own world. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e neare"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" she’d come was the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("r"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" paper of the year, with its coverage of the International Year of the Child, an imminent lorry drivers’ "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("rike and "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("cut")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("price")]), _vm._v(" blouses in Fras"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ers’ sale.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("She’d met up with a couple of school "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("iends "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a drink in the village pub, but that had been no better. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e chat "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("arted awkward and "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ilted, veered on to the com"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rting common ground of reminiscence, then backed into a "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("cul")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("de")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("sac")]), _vm._v(" of gossip about people she didn’t remember or had never met. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e pa"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("w years seemed to have severed her "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om old acq"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("uaintance.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("As the train had pulled out of Kirkcaldy on the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("r"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" leg of the journey back to Glasgow, Allie had "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("lt the lightness of reprieve. She’d waved duti"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("lly to her parents, "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("anding on the snowy plat"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rm. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey’d driven her the eight miles to the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ation "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rmer mining village of Ea"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" Wemyss where she’d grown up, and she wondered whether they shared her sense "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("of relief.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey had nothing to say to each other. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at was at the heart of the discom"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rt she "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("lt whenever she returned home. She’d slowly come to the realisation that they never had. Only, when she was growing up, that lack of connection had been masked by the daily routines of work and school, Girl Guides and bowling club, Women’s Guild and ho"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ckey team.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("en Allie had gone to university in another country and been parachuted into li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v(" on Mars. Everything in Cambridge had been "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("range. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e accents, the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("od, the expectations, the preoccupations. She’d quickly assimilated. She believed she’d "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("und her tribe at la"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(". "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ree years "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("ew by, but then she was unceremoniously ca"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" adri")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("And now, a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("er two years in the "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("North")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("Ea")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _vm._v(" of England learning a trade, she was back in Scotland. It wasn’t what she’d planned. She’d been aiming "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r Fleet Street and a national daily. But the news editor on her "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nal training scheme po"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" was an old drinking buddy of his opposite number on the "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Daily Clarion ")]), _vm._v("in Glasgow. And it was a national daily, if you counted Scotland as a nation. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("rapline on the paper said, ‘One adult in two in Scotland reads the "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Clarion")]), _vm._v("’. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e wags in the o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ce added, ‘"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e other one cannae read.’ Strings had been pulled, an o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffe")]), _vm._v("r made. She couldn"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("’t re")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("se.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("She’d had "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ve years of a su"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("cient di"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ance to keep her visits home to a minimum. But now it was impossible to avoid the signi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("cant dates. Birthdays. Family celebrations. And because it was Scotland,"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" Hogmanay.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Which meant three evenings of endless Fe"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ive Specials and musicals – "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Oliver!")]), _vm._v(", "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("My Fair Lady")]), _vm._v(", "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Half a Sixpence.")]), _vm._v(" She’d wanted to watch Jack Lemmon and Shirley MacLaine in "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Th")])]), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("e Apartment")]), _vm._v(", but once her mother had read the brief summary in the newspaper li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ings, that had been "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("rmly o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" the agenda. Allie didn’t want to revisit the torture so she simply said, ‘How was your "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("New Year?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny sco"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffe")]), _vm._v("d. ‘Like every New Year I can remember. We’ve got the bigge"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("at, so everybody piles in to ours. My dad’s got "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ve si"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ers – Auntie Mary, Auntie Cathy, Aunty "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("eresa, Auntie Bernie and Aunt"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ie Senga.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie giggled. ‘You’ve got an Auntie Senga? For real? I thought Senga was ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" a j"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("oke name?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘No. It’s “Agnes” backwards. She was baptised Agnes, but she goes by Senga. She says, anything to avoid being call"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ed Aggie.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I get that. So your "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ve aunties c"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ome over?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny nodded. ‘Five aunties, "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("ur uncles and assorted"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" cousins.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Only "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("u"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("r uncles?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Yeah, Uncle Paul got killed at his work. He was crushed by a whisky barrel in the bonded warehouse down at Leith.’ He pulled a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ce. ‘My dad said it might have had something to do with a signi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("cant amount of the whisky being inside Uncle Paul at "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("the time.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘So you have a big "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("mi"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ly party?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Yep. Same every year. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e aunties all do their specialities. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("eresa borrows the big soup pot "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om the church and makes a vat of lentil soup. Mary does rolls on potted hough. Cathy bakes the be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" sausage rolls in Edinburgh, my mum makes meat loaf, Bernie brings black bun that nobody eats, plus "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("shop")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("bought")]), _vm._v(" shortbread, and Senga produces three "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("avours o"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("f tablet.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Bloody hell, that’s some "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(".’ He didn’t look like someone who exi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ed on that kind of traditional Scottish diet. Danny was slender as a greyhound, with the high cheekbones, narrow nose and sharp chin of a medieval ascetic. Only his tumble of "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("collar")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("length")]), _vm._v(" curls made him look of"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" his time.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He grinned. ‘No kidding. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere’s enough in the house to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("ed half of Gorgie. And enough drink to open our"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" own pub.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘So what do you do? Eat and drink and"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" blether?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Well, we eat and drink and then everybody does their party piece. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at keeps us going till it’s time to turn on the telly "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the bells. And then Dad puts the Corries on the record player and it ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" gets more raucous. A "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("w of the neighbours come in to "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("r")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("-")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ot")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(".’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Sounds like a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rm of "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("self")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("-")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("de")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("nce")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny shrugged. ‘It’s a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("iendly close. What a"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("bout you?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie was spared "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om answering when the door at the end of the carriage clattered open and the conductor "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("aggered through, loaded with a pile of blankets. As he approached, he di"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ributed them among the hand"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("l of other passengers. ‘We’re going to be "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("uck here a while yet,’ he announced, a gloomy relish in his voice. ‘We’ve got to wait "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the snowplough to get here "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om Falkirk and it’s making slow progress, I’m told. And the heating’s went o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(". Sorry about that, but at lea"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" we’ve got some "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("blankets.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He handed each of them a coarse grey blanket that "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("lt more suitable "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a horse than a human. Allie wrapped it around her, nose wrinkling at the smell of mothballs. ‘Are you "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("eling the cold?’ Da"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("nny asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Not really. But now the heating’s o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(", we’ll lose our body heat pretty"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" quickly.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He eyed her across the narrow gap between their seats. ‘If you came and sat next to me, we could share the blankets. And the body heat.’ He gave her a "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("wide")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("eyed")]), _vm._v(" smile. ‘I’m not trying anything on. Ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" being sel"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("sh. Look at me, there’s nothing of me. I really su"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffe")]), _vm._v("r with "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("the cold.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was no denying that he was well wrapped up. Walking boots, corduroy trousers tucked into thick woollen socks, chunky "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("polo")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("neck")]), _vm._v(" sweater peeping out of his heavy overcoat. Woolly gloves, and a knitted hat "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("icking out of a pocket. Allie didn’t think she’d ever seen anyone better equipped "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the cold. Not even her grand"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ther, a man addicted to being out in the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("esh air whatever the weather. A li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("time of the coal "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ce would do that to you. ‘OK,’ she said, pretending a reluctance she didn’t "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("el. He was probably the only man in the newsroom who didn’t give o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" a predatory vibe. Arguably, you had to have the in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("incts of a predator to be a good reporter. But equally, you should know when to turn"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" them o")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie swapped seats. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("ssed with the blankets till they’d con"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ructed a "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("double")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("thickness")]), _vm._v(" shroud around themselves. ‘What shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" are you on next?’ she "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("asked him.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Day shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" tomor"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("row. You?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("She pulled a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ce. ‘I’m supposed to be on the night shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" tonight. Unless that bloody snowplough gets a move on, I’m going to be in big"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" trouble.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘You’ve got time. It’s barely gone three. And even if you don’t make it in on time, you’ll not be the only one. You working on anything or ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" the "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("day")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("to")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("day")]), _vm._v("?’ He spoke with a casualness that begged the return"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" que")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ion.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Waiting "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the next news "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory to drop. You know what it’s like on the night shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(". What a"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("bout you?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He smiled. ‘I’ve been chasing a big one. An inve"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("igation. I’ve been on it "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("w weeks, in between chasing ambulances. I got a whisper "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om somebody who didn’t even know what he was telling me and I’ve been trying to bottom it ever since. Mo"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ly in my own time. Grunts like you and me, we’re not supposed to do "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ories like this. We’re supposed to pass it on to the news desk and let one of the glory boys lead the charge. We get to do the dirty work round the edges, but we don’t get the"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" bylines.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("It was no less than the truth. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was a cohort of reporters who had titles – crime correspondent, chief reporter, education correspondent, court reporter and half a dozen others. When the lower orders uncovered a big "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory, it would immediately be snapped up by one of the guys who could claim it "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("e"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fd")]), _vm._v("om. ‘So how did you hang "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("on to it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I haven’t told anybody about it yet,’ Danny said simply. ‘I’m holding on to it till it’s too "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("r down the line "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r anybody to take it o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" me. But it’s "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("dynamite.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("lt a pang of jealousy. But it wasn’t directed at Danny. It was more a longing "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a major "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory of her own. ‘What’s it about? When’s it going to "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("be ready?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Soon. All I need is the la"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" piece of the jigsaw. Next long weekend, I’ve got to make a wee trip down south and "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nd the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nal bit"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("s of sky.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("So, not long then. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Clarion ")]), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" worked "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("ur long shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("s per week, a pattern that was so arranged that it gave them "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ve consecutive days o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" every three weeks. Allie "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ill hadn’t entirely worked out how be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" to use the time, though until the winter had set in she’d been developing a ta"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("e "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r hillwalking. But she was working up to buying a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("at and she could see an endless vi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("a of decorating and home improvement in her "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("ture. ‘Good "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r you. If you need"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" a grunt—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Again the door clattered open. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("is time, the guard was "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("red")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ced")]), _vm._v(" and agitated. ‘Are any of youse a doctor?’ He looked around, desperate. ‘Or"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" a nurse?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re anyone could respond, "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om behind him, a woman’s scream split the air. ‘I’m going to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("cking kill you, ya"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" ba")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ard.’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-612b7758","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802159038-7.vue
// module id = 84
// module chunks = 0